import VueCookies from 'vue-cookies';
import axios from 'axios';
import { parameter } from '@/axios/api.js';

// todo: 待修繕
import i18n from '@/i18n.js';

let apiurl = window.location.origin + "/";
if (window.location.hostname == "localhost") {
    apiurl = "https://localhost:44371/";
}

const request = axios.create({ baseURL: apiurl });

const $http = function (config) {
    const vue = this;
    config.headers = { 'Authorization': 'Basic ' + VueCookies.get('g'), ...config.headers };
    return request(config)
        .catch(function (error) {
            let message = error.response ? `${error.response.status} ${error.response.data.Message}` : error.toString();
            if (i18n.locale === 'en') {
                // todo: 待修繕
                if (message.includes('學年度 欄位是必要項。')) message = message.replace('學年度 欄位是必要項。', 'Academic year is required. ');
                if (message.includes('學期 欄位是必要項。')) message = message.replace('學期 欄位是必要項。', 'Semester is required. ');
                if (message.includes('活動名稱 欄位是必要項。')) message = message.replace('活動名稱 欄位是必要項。', 'Activity name is required. ');
                if (message.includes('活動目的 欄位是必要項。')) message = message.replace('活動目的 欄位是必要項。', 'Activity objectives is required. ');
                if (message.includes('日期(起) 欄位是必要項。')) message = message.replace('日期(起) 欄位是必要項。', 'Date (from) is required. ');
                if (message.includes('時間(起) 欄位是必要項。')) message = message.replace('時間(起) 欄位是必要項。', 'Time (from) is required. ');
                if (message.includes('日期(訖) 欄位是必要項。')) message = message.replace('日期(訖) 欄位是必要項。', 'Date (to) is required. ');
                if (message.includes('時間(訖) 欄位是必要項。')) message = message.replace('時間(訖) 欄位是必要項。', 'Time (to) is required. ');
                if (message.includes('地點 欄位是必要項。')) message = message.replace('地點 欄位是必要項。', 'Venue is required. ');
                if (message.includes('社團 欄位是必要項。')) message = message.replace('社團 欄位是必要項。', 'Club is required. ');
                if (message.includes('負責人學號 欄位是必要項。')) message = message.replace('負責人學號 欄位是必要項。', 'Responsible student ID number is required. ');
                if (message.includes('負責人姓名 欄位是必要項。')) message = message.replace('負責人姓名 欄位是必要項。', 'Responsible student name is required. ');
                if (message.includes('負責人班級 欄位是必要項。')) message = message.replace('負責人班級 欄位是必要項。', 'Responsible student class is required. ');
                if (message.includes('負責人連絡電話 欄位是必要項。')) message = message.replace('負責人連絡電話 欄位是必要項。', 'Responsible student contact number is required. ');
                if (message.includes('負責人聯絡信箱 欄位是必要項。')) message = message.replace('負責人聯絡信箱 欄位是必要項。', 'Responsible student E-mail is required. ');
                if (message.includes('負責人聯絡信箱 欄位是必要項。')) message = message.replace('負責人聯絡信箱 欄位是必要項。', 'Responsible student E-mail is required. ');
                if (message.includes('請填寫「活動經費支出預算表」')) message = message.replace('請填寫「活動經費支出預算表」', 'Activity expenditure budget is required. ');
                if (message.includes('請填寫「預期成效」並儲存')) message = message.replace('請填寫「預期成效」並儲存', 'Expected outcomes is required and sould save. ');
                if (message.includes('請填寫「活動流程內容詳述(請按時間寫明人、事、物)」並儲存')) message = message.replace('請填寫「活動流程內容詳述(請按時間寫明人、事、物)」並儲存', 'Details of the activity process is required and sould save. ');
                if (message.includes('「經費來源」與「活動經費支出預算表」經費總額不一致')) message = message.replace('「經費來源」與「活動經費支出預算表」經費總額不一致', '「Source of funding」and「Activity expenditure budget」need the same. ');
                if (message.includes('請填寫「活動經費支出明細表」')) message = message.replace('請填寫「活動經費支出明細表」', 'Activity expenditure budget is required. ');
                if (message.includes('核心能力(軟實力)-統計圖一說明 欄位是必要項。')) message = message.replace('核心能力(軟實力)-統計圖一說明', 'Core competencies (soft skills) description of Figure1 is required. ');
                if (message.includes('核心能力(軟實力)-統計圖二說明 欄位是必要項。')) message = message.replace('核心能力(軟實力)-統計圖二說明', 'Core competencies (soft skills) description of Figure2 is required. ');
                if (message.includes('活動滿意度分析圖一說明 欄位是必要項。')) message = message.replace('活動滿意度分析圖一說明', 'Activity Satisfaction Analysis Chart description of Figure1 is required. ');
                if (message.includes('活動照片剪影圖一說明 欄位是必要項。')) message = message.replace('活動照片剪影圖一說明', 'Activity photo silhouettes description of Figure1 is required. ');
                if (message.includes('活動照片剪影圖二說明 欄位是必要項。')) message = message.replace('活動照片剪影圖二說明', 'Activity photo silhouettes description of Figure2 is required. ');
                if (message.includes('活動照片剪影圖三說明 欄位是必要項。')) message = message.replace('活動照片剪影圖三說明', 'Activity photo silhouettes description of Figure3 is required. ');
                if (message.includes('活動照片剪影圖四說明 欄位是必要項。')) message = message.replace('活動照片剪影圖四說明', 'Activity photo silhouettes description of Figure4 is required. ');
                if (message.includes('活動建議事項與檢討反饋 欄位是必要項。')) message = message.replace('活動建議事項與檢討反饋 欄位是必要項。', 'Activity Suggestions and Review Feedback is required. ');
                if (message.includes('活動建議事項與檢討反饋至少需150個字')) message = message.replace('活動建議事項與檢討反饋至少需150個字', 'Activity Suggestions and Review Feedback(at least 150 words). ');
                if (message.includes('活動自評與心得感想 欄位是必要項。')) message = message.replace('活動自評與心得感想 欄位是必要項。', 'Activity self-assessment and reflections is required. ');
                if (message.includes('活動自評與心得感想至少需500個字')) message = message.replace('活動自評與心得感想至少需500個字', 'Activity self-assessment and reflections(at least 500 words). ');
            }
            if (vue && vue.$bvToast) {
                let title = i18n.locale === 'en' ? 'error' : '發生錯誤';
                vue.$bvToast.toast(message, { title: title, variant: 'danger', solid: true });
            }
            return Promise.reject(error);
        })
        .finally(function () {
            if (VueCookies.isKey('g')) {
                VueCookies.set('g', VueCookies.get('g'), 1200);
            }
        });
};

const $file = function (config) {
    let formData = new FormData();
    formData.append("file", config.file);

    config.data = formData;
    config.headers = { 'Content-Type': 'multipart/form-data' };

    return $http(config);
};

const install = function (Vue) {
    Vue.prototype.$apiurl = apiurl;
    Vue.prototype.$http = $http;
    Vue.prototype.$file = $file;
    Vue.prototype.$parameter = parameter;
};

export default { install };
export { apiurl, $http, $file }